import { ResidentialRentComp, ResidentialRentRollUnit } from 'types/underwriting/income-approach';
import { isNil } from 'lodash';

export const calculateMonthlyRentSummary = (subjectUnits: ResidentialRentRollUnit[], comps: ResidentialRentComp[]) => {
  const subjectUnitsWithRent = subjectUnits.filter((unit) => unit.rent);
  const subjectUnitsMap = {
    min: Math.min(...subjectUnitsWithRent.map((unit) => unit.rent!)),
    max: Math.max(...subjectUnitsWithRent.map((unit) => unit.rent!)),
    average: subjectUnitsWithRent.reduce((sum, unit) => sum + unit.rent!, 0) / subjectUnitsWithRent.length,
  };

  const compsMap = {
    min: Math.min(...comps.map((comp) => comp.monthlyRent)),
    max: Math.max(...comps.map((comp) => comp.monthlyRent)),
    average: comps.reduce((sum, comp) => sum + comp.monthlyRent, 0) / comps.length,
  };

  return {
    subjectUnits: subjectUnitsMap,
    comps: compsMap,
  };
};

export const getSubjectUnitGroups = (rentRoll: ResidentialRentRollUnit[]) => {
  const groups: { [key in number]: { bedrooms: number; units: ResidentialRentRollUnit[] } } = {};
  (rentRoll || [])
    .filter((unit: ResidentialRentRollUnit) => !isNil(unit.bedrooms))
    .forEach((unit: ResidentialRentRollUnit) => {
      groups[unit.bedrooms!] = groups[unit.bedrooms!]
        ? { bedrooms: groups[unit.bedrooms!].bedrooms, units: [...groups[unit.bedrooms!].units, unit] }
        : { bedrooms: unit.bedrooms!, units: [unit] };
    });
  return Object.values(groups);
};
